import React from "react"
import { Box } from "@mui/material"
import { DatePickerSeeker, disabledBefore, disabledBeforeToday } from "@ui-seeker/core"
import { AppNote } from "@components"
import { useReportExecutionDatesMultiple } from "Pages/ReportsAlerts/Reports/@hooks"


export default function ReportMultiModalExecutionDatesSection() {

	const {
		executionDateMin,
		executionDateMax,
		setExecutionDateMin,
		setExecutionDateMax
	} = useReportExecutionDatesMultiple()

	return <>
		<AppNote sx={{ mb: 2.5 }}>
			Apply with both dates empty to clear the execution date range of every selected report.
		</AppNote>
		<Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
			<DatePickerSeeker
				cleanable
				label="Date Min Execution"
				shouldDisableDate={disabledBeforeToday()}
				value={executionDateMin}
				onChange={e => setExecutionDateMin(e)}
			/>
			<DatePickerSeeker
				cleanable
				label="Date Max Execution"
				shouldDisableDate={disabledBefore(executionDateMin)}
				value={executionDateMax}
				onChange={e => setExecutionDateMax(e)}
			/>
		</Box>
	</>
}
